module.exports = __webpack_public_path__ + "images/[7]3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[7]3.jpeg
// module id = 38
// module chunks = 0